import { render, staticRenderFns } from "./salaryReport.vue?vue&type=template&id=7678fadb&scoped=true&"
import script from "./salaryReport.vue?vue&type=script&lang=ts&"
export * from "./salaryReport.vue?vue&type=script&lang=ts&"
import style0 from "./salaryReport.vue?vue&type=style&index=0&id=7678fadb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678fadb",
  null
  
)

export default component.exports